import React, {useContext} from 'react';

import Footer_Content from './Footer_Content';

function Footer(props) {
    const copyright = '© 2023 BASF Canada Inc.';
    return (
        <React.Fragment>                     
            <Footer_Content copyright={copyright}></Footer_Content>
        </React.Fragment>
    );
}

export default Footer;